import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger.js";

gsap.registerPlugin(ScrollTrigger);

let growingPlantContainers = '.growing-plant__container'

if (growingPlantContainers) {

	gsap.utils.toArray(growingPlantContainers).forEach((container) => {
	  let growingPlant = container.querySelector('.growing-plant')

	  gsap.to(growingPlant, {
	  	duration: 1,
	    scrollTrigger: {
	      trigger: container,
	      toggleClass: {targets: growingPlant, className: 'is-active'},
	    },
	  });

	});
}


let growingPlantsHero = '.growing-plants__hero'
if (document.querySelector(".growing-plants__hero")) {
	gsap.from(growingPlantsHero, {duration: 2, scale: 0, transformOrigin: "bottom", stagger: .7}, "=-.5")
}
